export  const SearchHistoryConstant = {
    SEARCHHISTORY_SAGA: "SEARCHHISTORY_SAGA",
    SEARCHHISTORY_REQUEST: "SEARCHHISTORY_REQUEST",
    SEARCHHISTORY_RESPONSE: "SEARCHHISTORY_RESPONSE",
    SEARCHHISTORY_API: "/all-search-history",
  };
  